import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { RetryLink } from '@apollo/client/link/retry';
import { provideApolloClient } from '@vue/apollo-composable';
import router from '@/router';

const getHeaders = () => {
  const token = localStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_ENDPOINT,
  headers: getHeaders(),
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      ...getHeaders(),
    },
  };
});

// Error handling link (optional)
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
      if (
        message.includes(
          "Cannot read properties of undefined (reading 'project_id')"
        )
      ) {
        router.push({ path: '/page-not-found' });
      }
      // Remove access_token and user from local storage and redirect user to login page
      if (message.includes('Context creation failed')) {
        localStorage.setItem(
          'redirectAfterLogin',
          router.currentRoute.value.fullPath
        );
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
        window.location = window.origin;
      }
    });
  }
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

// Retry link configuration
const retryLink = new RetryLink({
  delay: {
    initial: 300, // Initial delay in ms
    max: 3000, // Maximum delay in ms
    jitter: true, // Randomize delay to prevent thundering herd problem
  },
  attempts: {
    max: 2, // Maximum number of retries
  },
});

// Combine the links
const link = ApolloLink.from([authLink, retryLink, errorLink, httpLink]);

const cache = new InMemoryCache({
  typePolicies: {
    library: {
      keyFields: ['id'],
    },
    assets: {
      keyFields: ['id'],
    },
    asset: {
      keyFields: ['id'],
    },
    Distribution: {
      fields: {
        config: {
          merge(existing, incoming) {
            return { ...existing, ...incoming };
          },
        },
      },
    },
    Query: {
      fields: {
        list_assets: {
          merge(existing, incoming) {
            return { ...existing, ...incoming };
          },
        },
        action: {
          merge(existing, incoming) {
            return { ...existing, ...incoming };
          },
        },
      },
    },
  },
});
const apolloClient = new ApolloClient({
  link,
  cache,
});

provideApolloClient(apolloClient);

export default apolloClient;
